<template>
  <comTable :config="tableConfig">
  </comTable>
</template>
<script>
import comTable from "@/components/firTable.vue";
export default {
  components: { comTable },
  data() {
    return {
      tableConfig: {
        url: "adminBehaviorList",
        list: [
          { label: "管理员ID", prop: "admin_id" },
          { label: "管理员昵称", prop: "admin_username" },
          { label: "操作模块", prop: "module" },
          { label: "控制器", prop: "controller" },
          { label: "页面控制", prop: "action" },

          { label: "sql类型", prop: "operate" },
          { label: "执行sql语句",type:'html', prop: "result",clfn:da=>{
            return `<div class="hids_001"><div>${da.result}</div></div>`
          } },
          { label: "操作ip", prop: "ip" },
          { label: "操作时间", prop: "updated_at" },

        ],
      },
    };
  },
};
</script>
<style>
.hids_001{
  height: 40px;
  overflow: hidden;
  overflow-y: auto;
}
</style>